import * as React from 'react';
import ReactDom from 'react-dom';
import { autoPositionByRef } from './utils/auto-position-item';
import { PopOverPrimitive } from './pop-over.primitive';
const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
const EVENT_LISTENER_OPTIONS = parseInt(React.version.split('.')[0]) >= 17 ? { capture: true } : {};
export const PopOver = ({ alwaysUp = false, children, className, isInFlow = false, isStatic, offset, onOutsideClick, show = false, triggerRef, ...props }) => {
    const containerRef = React.useRef(null);
    const [position, setPosition] = React.useState({});
    const reposition = React.useCallback(() => {
        if (show && !isStatic) {
            const newPosition = autoPositionByRef(triggerRef, containerRef, isInFlow, offset, alwaysUp);
            setPosition(newPosition);
        }
    }, [alwaysUp, isInFlow, isStatic, offset, show, triggerRef]);
    useIsomorphicLayoutEffect(() => {
        reposition();
    }, [triggerRef, containerRef, show, reposition]);
    React.useEffect(() => {
        const checkOutSideClick = (e) => {
            if ((containerRef &&
                containerRef.current &&
                containerRef.current.contains(e.target)) ||
                (triggerRef &&
                    triggerRef.current &&
                    triggerRef.current.contains(e.target))) {
                return;
            }
            onOutsideClick && onOutsideClick();
        };
        if (show) {
            window.addEventListener('resize', reposition, EVENT_LISTENER_OPTIONS);
            document.addEventListener('click', checkOutSideClick, EVENT_LISTENER_OPTIONS);
        }
        return () => {
            window.removeEventListener('resize', reposition, EVENT_LISTENER_OPTIONS);
            document.removeEventListener('click', checkOutSideClick, EVENT_LISTENER_OPTIONS);
        };
    }, [onOutsideClick, reposition, show, triggerRef]);
    if (show && isInFlow) {
        return (React.createElement(PopOverPrimitive, { className: className, containerRef: containerRef, position: position, ...props }, children));
    }
    else if (show) {
        return ReactDom.createPortal(React.createElement(React.Fragment, null,
            React.createElement(PopOverPrimitive, { className: className, containerRef: containerRef, position: position, ...props }, children)), document.body);
    }
    else {
        return null;
    }
};
PopOver.displayName = 'PopOver';
//# sourceMappingURL=pop-over.js.map